import { writable } from "svelte/store";

export let editingSupersetID = writable<null | number>(null);
